/* eslint-disable camelcase, react/no-find-dom-node, no-underscore-dangle */
import { Component } from 'react';
import PropTypes from 'prop-types';
import ReactDOM, { unstable_renderSubtreeIntoContainer } from 'react-dom';
import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';
import './Tooltip.css';

class Tooltip extends Component {
  componentDidMount() {
    const node = ReactDOM.findDOMNode(this);
    const { children, ...props } = this.props;
    if (props.html) {
      const el = document.createElement('div');
      unstable_renderSubtreeIntoContainer(this, props.html, el);
      props.html = el;
    }
    tippy(node, props);
    this.tippyInstance = node._tippy;
  }

  componentWillUnmount() {
    if (this.tippyInstance) {
      this.tippyInstance.destroy();
      this.tippyInstance = null;
    }
  }

  render() {
    return this.props.children;
  }
}

Tooltip.defaultProps = {
  html: undefined
};

Tooltip.propTypes = {
  children: PropTypes.node.isRequired,
  html: PropTypes.node
};

export default Tooltip;



// WEBPACK FOOTER //
// ./src/components/edu/Tooltip.js